export type MemberRetirementAges = Readonly<Record<string, number>>

type MemberLike = { id: string; retirementAge: number }

export const buildMemberRetirementAges = (
  members: ReadonlyArray<MemberLike>
): MemberRetirementAges =>
  Object.fromEntries(members.map(m => [m.id, m.retirementAge]))
